export default __webpack_public_path__ + "static/back_decoration-3f2e02b4309c3d02df311a4eb8a62376.png";